import { render, staticRenderFns } from "./AnxContent.vue?vue&type=template&id=2eb4993f&scoped=true&"
import script from "./AnxContent.vue?vue&type=script&lang=ts&"
export * from "./AnxContent.vue?vue&type=script&lang=ts&"
import style0 from "./AnxContent.vue?vue&type=style&index=0&id=2eb4993f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4993f",
  null
  
)

export default component.exports